export default __webpack_public_path__ + "static/logo-1ef18ff691afbcfce6261ca3dbb06791.png";